import { jsPDF } from 'jspdf'
import 'jspdf-autotable'

export function usePrototipoPDF() {

  const generarPDFEspecificacion = (prototipo) => {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'mm',
      format: 'letter'
    })

    const pageWidth = doc.internal.pageSize.getWidth()
    const pageHeight = doc.internal.pageSize.getHeight()

    // Colores exactos del documento original
    const colorNaranja = [255, 102, 0]      // Headers principales
    const colorAzul = [0, 76, 153]          // MATERIALES, RECUBRIMIENTO
    const colorGris = [128, 128, 128]       // PEGADO, EMPACADO
    const colorNegro = [0, 0, 0]            // PROCESOS
    const colorBlanco = [255, 255, 255]

    // ==========================================
    // HEADER - Logo Myco y Título
    // ==========================================
    // Logo Myco (caja naranja)
    doc.setFillColor(...colorNaranja)
    doc.roundedRect(5, 5, 35, 12, 2, 2, 'F')
    doc.setTextColor(...colorBlanco)
    doc.setFontSize(18)
    doc.setFont('helvetica', 'bold')
    doc.text('Myco', 10, 13)

    // Título centrado
    doc.setFontSize(14)
    doc.setFont('helvetica', 'bold')
    doc.setTextColor(...colorNegro)
    const titulo = 'ESPECIFICACIÓN DEL PRODUCTO'
    const tituloX = (pageWidth - doc.getTextWidth(titulo)) / 2
    doc.text(titulo, tituloX, 13)

    // Cliente y Fecha en header (lado derecho)
    doc.setFontSize(8)
    doc.setFont('helvetica', 'bold')
    doc.text('Cliente', pageWidth - 60, 8)
    doc.setFont('helvetica', 'normal')
    doc.text(prototipo.cliente?.nombre || 'N/A', pageWidth - 60, 12)

    doc.setFont('helvetica', 'bold')
    doc.text('Fecha act.', pageWidth - 35, 8)
    doc.setFont('helvetica', 'normal')
    const fecha = new Date().toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' })
    doc.text(fecha, pageWidth - 35, 12)

    let yPos = 20

    // ==========================================
    // SECCIÓN: PRODUCTO
    // ==========================================
    // Header naranja "Producto"
    doc.setFillColor(...colorNaranja)
    doc.rect(5, yPos, 135, 6, 'F')
    doc.setTextColor(...colorBlanco)
    doc.setFontSize(9)
    doc.setFont('helvetica', 'bold')
    doc.text('Producto', 7, yPos + 4)

    // Contenido del producto
    doc.setDrawColor(200)
    doc.setLineWidth(0.1)
    doc.rect(5, yPos + 6, 135, 8)
    doc.setTextColor(...colorNegro)
    doc.setFontSize(9)
    doc.setFont('helvetica', 'normal')
    doc.text(prototipo.codigo || 'N/A', 7, yPos + 11)

    // ==========================================
    // SECCIÓN: DIMENSIONES (EN CM) - derecha
    // ==========================================
    doc.setFillColor(...colorAzul)
    doc.rect(142, yPos, 133, 6, 'F')
    doc.setTextColor(...colorBlanco)
    doc.setFont('helvetica', 'bold')
    doc.text('DIMENSIONES (en CM)', 144, yPos + 4)

    yPos += 6

    // Internas, Pleca a Pleca, etc.
    doc.setDrawColor(200)
    doc.rect(142, yPos, 40, 8)
    doc.setTextColor(...colorNegro)
    doc.setFontSize(7)
    doc.setFont('helvetica', 'bold')
    doc.text('Internas', 144, yPos + 3)
    doc.setFontSize(8)
    doc.setFont('helvetica', 'normal')

    // Buscar dimensiones en el prototipo
    let dimensionesInternas = '0 x 0 x 0'
    if (prototipo.secciones && prototipo.secciones.length > 0) {
      const seccion = prototipo.secciones[0]
      if (seccion.componentes && seccion.componentes.length > 0) {
        const comp = seccion.componentes[0]
        const ancho = comp.campos?.find(c => c.nombre?.toLowerCase().includes('ancho'))?.valor || '0'
        const alto = comp.campos?.find(c => c.nombre?.toLowerCase().includes('alto'))?.valor || '0'
        dimensionesInternas = `${ancho} x ${alto} x 0`
      }
    }
    doc.text(dimensionesInternas, 144, yPos + 7)

    // Int. Cliente
    doc.rect(182, yPos, 40, 8)
    doc.setFontSize(7)
    doc.setFont('helvetica', 'bold')
    doc.text('Int. Cliente', 184, yPos + 3)
    doc.setFontSize(8)
    doc.setFont('helvetica', 'normal')
    doc.text('0 x 0 x 0', 184, yPos + 7)

    // Dimensiones (lado derecho duplicado)
    doc.rect(224, yPos, 51, 8)
    doc.setFontSize(7)
    doc.setFont('helvetica', 'bold')
    doc.text('Dimensiones', 226, yPos + 4)

    yPos += 8

    // Pleca a Pleca
    doc.rect(142, yPos, 133, 6)
    doc.setFontSize(7)
    doc.setFont('helvetica', 'bold')
    doc.text('Pleca a Pleca', 144, yPos + 4)

    yPos += 6

    // ==========================================
    // SECCIÓN: MATERIALES (azul)
    // ==========================================
    doc.setFillColor(...colorAzul)
    doc.rect(142, yPos, 85, 6, 'F')
    doc.setTextColor(...colorBlanco)
    doc.setFontSize(9)
    doc.setFont('helvetica', 'bold')
    doc.text('MATERIALES', 144, yPos + 4)

    doc.rect(229, yPos, 46, 6)
    doc.setTextColor(...colorNegro)
    doc.text('Dimensiones', 231, yPos + 4)

    yPos += 6

    // Exterior
    doc.setDrawColor(200)
    doc.rect(142, yPos, 20, 6)
    doc.setTextColor(...colorNegro)
    doc.setFontSize(7)
    doc.setFont('helvetica', 'bold')
    doc.text('Exterior', 144, yPos + 4)

    // Material exterior
    doc.rect(162, yPos, 65, 6)
    doc.setFontSize(8)
    doc.setFont('helvetica', 'normal')
    let materialExterior = 'N/A'
    if (prototipo.secciones?.[0]?.componentes?.[0]) {
      materialExterior = prototipo.secciones[0].componentes[0].tipo_componente?.nombre || 'N/A'
    }
    doc.text(materialExterior, 164, yPos + 4)

    // Dimensiones exterior
    doc.rect(229, yPos, 46, 6)
    doc.text(dimensionesInternas, 231, yPos + 4)

    yPos += 6

    // Interior
    doc.rect(142, yPos, 20, 6)
    doc.setFontSize(7)
    doc.setFont('helvetica', 'bold')
    doc.text('Interior', 144, yPos + 4)

    doc.rect(162, yPos, 65, 6)
    doc.setFontSize(8)
    doc.setFont('helvetica', 'normal')
    doc.text(materialExterior, 164, yPos + 4)

    doc.rect(229, yPos, 46, 6)
    doc.text(dimensionesInternas, 231, yPos + 4)

    yPos += 6

    // ==========================================
    // PLANEACIÓN
    // ==========================================
    doc.rect(5, 34, 135, 6)
    doc.setFontSize(7)
    doc.setFont('helvetica', 'bold')
    doc.text('Planeación', 7, 38)

    doc.rect(5, 40, 25, 6)
    doc.text('Pz x Hoja', 7, 44)

    doc.rect(30, 40, 25, 6)
    doc.text('Pinza Mat.', 32, 44)

    doc.rect(55, 40, 25, 6)
    doc.text('Suajado', 57, 44)

    // Valores
    doc.rect(5, 46, 25, 6)
    doc.setFont('helvetica', 'normal')
    doc.text('1', 12, 50)

    doc.rect(30, 46, 25, 6)
    doc.text('1.5 cm', 35, 50)

    doc.rect(55, 46, 25, 6)
    doc.text('Frente', 60, 50)

    // ==========================================
    // SECCIÓN: No. / TINTAS
    // ==========================================
    doc.setFillColor(...colorNaranja)
    doc.rect(5, 54, 15, 6, 'F')
    doc.setTextColor(...colorBlanco)
    doc.setFont('helvetica', 'bold')
    doc.text('No.', 7, 58)

    doc.setFillColor(...colorNaranja)
    doc.rect(20, 54, 55, 6, 'F')
    doc.text('TINTAS', 35, 58)

    // Contenido tintas
    doc.setDrawColor(200)
    doc.rect(5, 60, 15, 12)
    doc.setTextColor(...colorNegro)
    doc.setFontSize(9)
    doc.setFont('helvetica', 'normal')
    doc.text('1 / 1', 7, 67)

    doc.rect(20, 60, 15, 6)
    doc.setFontSize(7)
    doc.setFont('helvetica', 'bold')
    doc.text('Exterior', 22, 64)

    doc.rect(35, 60, 40, 6)
    doc.setFontSize(8)
    doc.setFont('helvetica', 'normal')
    doc.text('Negro', 37, 64)

    doc.rect(20, 66, 15, 6)
    doc.setFontSize(7)
    doc.setFont('helvetica', 'bold')
    doc.text('Interior', 22, 70)

    doc.rect(35, 66, 40, 6)
    doc.setFontSize(8)
    doc.setFont('helvetica', 'normal')
    doc.text('Negro', 37, 70)

    // ==========================================
    // SECCIÓN: RECUBRIMIENTO (azul)
    // ==========================================
    doc.setFillColor(...colorAzul)
    doc.rect(142, yPos, 60, 6, 'F')
    doc.setTextColor(...colorBlanco)
    doc.setFontSize(9)
    doc.setFont('helvetica', 'bold')
    doc.text('RECUBRIMIENTO', 144, yPos + 4)

    // ACABADOS
    doc.rect(204, yPos, 71, 6, 'F')
    doc.text('ACABADOS', 220, yPos + 4)

    yPos += 6

    // Contenido recubrimiento
    doc.setDrawColor(200)
    doc.rect(142, yPos, 60, 12)
    doc.setTextColor(...colorNegro)
    doc.setFontSize(8)
    doc.setFont('helvetica', 'normal')
    doc.text('Plastificado Ext.', 144, yPos + 4)
    doc.text('Barniz Acrílico Int.', 144, yPos + 9)

    // Contenido acabados
    doc.rect(204, yPos, 71, 12)
    doc.text('Barniz UV Brillante Ext.', 206, yPos + 4)
    doc.text('N/A', 206, yPos + 9)

    yPos += 12

    // ==========================================
    // SECCIÓN: PEGADO / EMPACADO / TARIMA (gris)
    // ==========================================
    doc.setFillColor(...colorGris)
    doc.rect(5, 74, 30, 6, 'F')
    doc.setTextColor(...colorBlanco)
    doc.setFont('helvetica', 'bold')
    doc.text('PEGADO', 12, 78)

    doc.rect(35, 74, 35, 6, 'F')
    doc.text('EMPACADO', 42, 78)

    doc.rect(70, 74, 70, 6, 'F')
    doc.text('TARIMA', 95, 78)

    // Contenido
    doc.setDrawColor(200)
    doc.rect(5, 80, 30, 6)
    doc.setTextColor(...colorNegro)
    doc.setFont('helvetica', 'normal')
    doc.text('N/A', 15, 84)

    doc.rect(35, 80, 35, 6)
    doc.text('Emplayado', 42, 84)

    doc.rect(70, 80, 35, 6)
    doc.setFontSize(7)
    doc.setFont('helvetica', 'bold')
    doc.text('Cant. Paquetes', 72, 83)
    doc.setFontSize(8)
    doc.setFont('helvetica', 'normal')
    doc.text('50', 100, 84)

    doc.rect(105, 80, 35, 6)
    doc.setFontSize(7)
    doc.setFont('helvetica', 'bold')
    doc.text('Tacón Madera', 107, 82)
    doc.setFontSize(8)
    doc.setFont('helvetica', 'normal')
    doc.text('1.0 x 1.2', 107, 85)

    // ==========================================
    // SECCIÓN: OBSERVACIONES
    // ==========================================
    doc.setFillColor(...colorNaranja)
    doc.rect(142, yPos, 133, 6, 'F')
    doc.setTextColor(...colorBlanco)
    doc.setFont('helvetica', 'bold')
    doc.text('OBSERVACIONES', 144, yPos + 4)

    yPos += 6

    doc.setDrawColor(200)
    doc.rect(142, yPos, 133, 20)
    doc.setTextColor(...colorNegro)
    doc.setFontSize(8)
    doc.setFont('helvetica', 'normal')
    const observaciones = prototipo.descripcion || 'Sin observaciones'
    const splitObs = doc.splitTextToSize(observaciones, 128)
    doc.text(splitObs, 144, yPos + 4)

    // ==========================================
    // SECCIÓN: PROCESOS (negro)
    // ==========================================
    doc.setFillColor(...colorNegro)
    doc.rect(5, 88, 135, 6, 'F')
    doc.setTextColor(...colorBlanco)
    doc.setFont('helvetica', 'bold')
    doc.text('PROCESOS', 7, 92)

    doc.setDrawColor(200)
    doc.rect(5, 94, 135, 8)
    doc.setTextColor(...colorNegro)
    doc.setFontSize(7)
    doc.setFont('helvetica', 'normal')
    doc.text('• Diseño • Preprensa • Impresión • Acabado • Barnizado • Refilado • Suajado • Empacado', 7, 99)

    // ==========================================
    // ÁREA DE DIAGRAMAS
    // ==========================================
    yPos = 104

    // Sección: Referencia Suaje
    doc.setDrawColor(200)
    doc.rect(5, yPos, 65, 6)
    doc.setFontSize(8)
    doc.setFont('helvetica', 'bold')
    doc.text('Referencia Suaje', 25, yPos + 4)

    doc.rect(72, yPos, 65, 6)
    doc.text('Referencia Acabado', 87, yPos + 4)

    yPos += 6

    // Área de diagramas (placeholder)
    doc.rect(5, yPos, 65, 85)
    doc.setFontSize(20)
    doc.setTextColor(200, 200, 200)
    doc.text('DIAGRAMA', 18, yPos + 45)

    doc.rect(72, yPos, 65, 85)
    doc.text('DIAGRAMA', 85, yPos + 45)

    // Generar el PDF
    const nombreArchivo = `Especificacion_${prototipo.codigo || 'Prototipo'}_${fecha.replace(/\//g, '-')}.pdf`
    doc.save(nombreArchivo)
  }

  return {
    generarPDFEspecificacion
  }
}
